import { render } from "./logoffModal.vue?vue&type=template&id=5d8615df&scoped=true&ts=true"
import script from "./logoffModal.vue?vue&type=script&lang=ts"
export * from "./logoffModal.vue?vue&type=script&lang=ts"

import "./logoffModal.vue?vue&type=style&index=0&id=5d8615df&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8615df"]])